import type { MouseEventHandler } from 'react';

import { Add as AddIcon, AssistantOutlined } from '@/shared/ui/icons';
import SideDrawer from '@/shared/ui/overlays/Drawer';
import Button from '@/shared/ui/primitives/Button';

import Chat from '@/features/ai-chat/components/AskGXDrawer/Chat/Chat';
import ChatHistory from '@/features/ai-chat/components/AskGXDrawer/ChatHistory/ChatHistory';
import InputDisclaimer from '@/features/ai-chat/components/AskGXDrawer/InputDisclaimer/InputDisclaimer';
import MessageInput from '@/features/ai-chat/components/AskGXDrawer/MessageInput/MessageInput';
import { ChatProvider } from './ChatProvider';

import { useAskGXContent } from './useAskGXContent';

const AskGXContent = ({ open, onClose }: { open: boolean; onClose: MouseEventHandler }) => {
  const {
    conversationId,
    setConversationId,
    messages,
    anchorEl,
    setAnchorEl,
    historyBtnRef,
    handleHistoryClick
  } = useAskGXContent();

  return (
    <SideDrawer
      headerAction={
        <Button
          color='primary'
          disabled={messages.length === 0 && conversationId !== null}
          size='large'
          sx={{
            '&.Mui-disabled': {
              backgroundColor: 'gx.textDisabled',
              color: 'gx.neutral',
              opacity: 1
            },
            width: '144px',
            height: '36px',
            padding: '4px 12px'
          }}
          variant='contained'
          onClick={() => {
            setConversationId('');
          }}
        >
          <AddIcon
            sx={{
              width: '24px',
              height: '24px'
            }}
          />
          New Chat
        </Button>
      }
      historyButtonRef={historyBtnRef}
      icon={
        <AssistantOutlined
          sx={{
            width: '32px',
            height: '32px'
          }}
        />
      }
      open={open}
      subtitle={
        <>
          Chat initialized with thread ID:{' '}
          {conversationId ?? 'There was an error. Please try again'}
        </>
      }
      title='GX Go Assistant'
      onClose={onClose}
      onHistoryClick={handleHistoryClick}
    >
      {open && (
        <>
          <Chat />
          <InputDisclaimer />
          <MessageInput maxRows={3} />
          <ChatHistory
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
          />
        </>
      )}
    </SideDrawer>
  );
};

const AskGXDrawer = ({ open, onClose }: { open: boolean; onClose: MouseEventHandler }) => {
  return (
    <ChatProvider open={open}>
      <AskGXContent
        open={open}
        onClose={onClose}
      />
    </ChatProvider>
  );
};

export default AskGXDrawer;
